// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import briefcase02Icon from "@/assets/icons/briefcase-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Briefcase02IconProps = Omit<IconProps, "name">;

export function Briefcase02Icon(props: Briefcase02IconProps): React.ReactNode {
  return <Icon name={briefcase02Icon} {...props} />;
}
